import { DataTableColumnHeader } from "@/components/ui";
import { type MatterNote } from "@/lib/types";
import { convertToLocalFromDatabaseDateTime } from "@/lib/utils/dateUtils";
import { formatDate } from "@/lib/utils/format";
import { type ColumnDef, createColumnHelper } from "@tanstack/react-table";

export type NotesWithType = MatterNote & {
  type: string;
  itemId: string;
};

const columnHelper = createColumnHelper<NotesWithType>();

export const matterNoteTableColumns: ColumnDef<NotesWithType>[] = [
  columnHelper.accessor((note) => note.publishedDate, {
    id: "Date Created",
    sortingFn: "customDateTime",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: (row) => (
      <div>
        {formatDate(convertToLocalFromDatabaseDateTime(row.getValue()))}
      </div>
    ),
  }),
  columnHelper.accessor("pinned", {
    id: "Pinned",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: (row) => <div>{row.getValue() ? "Yes" : "No"}</div>,
  }),
] as ColumnDef<NotesWithType>[];
